module.exports = __webpack_public_path__ + "media/images/brands/logo_franchienergia_grande-5dff829480a5ec298312ea203d0f4648.png";